import { ApplicationAction } from "./applicationActions";
import { ApplicationState, Step } from "./applicationState";
import { PaymentMethod } from "../../lib-api";
import { array } from "prop-types";
import { stat } from "fs/promises";

const initialState: ApplicationState = {
    currentStep: Step.Main,
    data: {
        loanAmount: 75000,
        startAmount: 75000,
        repaymentPeriod: 72,
        cpr: "",
        oldLoanAmount: "",
        name: "",
        mobile: "",
        email: "",
        address: "",
        postalcode: "",
        city: "",
        aseConsent: false,
        marketingConsent: false,
        almBrandConsent: false,
        coname: null,
        coemail: null,
        cocpr: null,
        married: "",
        rki: false,
        dwelling: "",
        reasonOfLoan: "",
        otherReasonOfLoan: "",
        coappliant: false,
        cars: [],
        paymentMethod: null,
        hasOldLoan: null,
        termsOfService: false,
        creditCheck: false,
        insurance: false,
        marketing: false,
        eSkatConsent: false,
        children: [],
        sharedExpenses: null,
        rent: "",
        maritalExpenses: "",
        step2AltLink: "",
        step2AltText: "",
       
      
        

     


    },
    application: {
        id: "",
        sending: false,
        data: null,
        error: null,
        lastStep: Step.Main,
    },
};

/* TEST DATA */

//initialState.currentStep = Step.Payment;
//initialState.data.cpr = "0707614293";
// initialState.data.name = "Lars Henriksen";
// initialState.data.mobile = "22906669";
// initialState.data.email = "af@heymate.dk";
// initialState.data.tos = true;
// initialState.data.cars = 1;
// initialState.data.paymentMethod = PaymentMethod.PBS;

// initialState.application.error = <any>{
//   statusText: "FEJL"
// };

function applicationReducer(
    state: ApplicationState = initialState,
    action: ApplicationAction
): ApplicationState {
    switch (action.type) {
        case "SET_APPLICATION_AMOUNT":
            return {
                ...state,
                data: {
                    ...state.data,
                    loanAmount: action.amount,
                    
                },
                application: {
                    id: "",
                    sending: false,
                    data: null,
                    error: null,
                    lastStep: Step.Amount,
                },
                currentStep: Step.Amount,
             
            };
        case "SET_APPLICATION_AMOUNT_OTHER":
            return {
                ...state,
                data: {
                    ...state.data,
                    loanAmount: action.amount,
                },
                currentStep: Step.AmountAlt,
                application: {
                    id: "",
                    sending: false,
                    data: null,
                    error: null,
                    lastStep: Step.AmountAlt,
                },
            };
        case "SET_APPLICATION_STEP2_ALT":
            return {
                ...state,
                data: {
                    ...state.data,
                    step2AltLink: action.link,
                    step2AltText: action.text
                },
            };
        case "SET_APPLICATION_START_AMOUNT":
            return {
                ...state,
                data: {
                    ...state.data,
                    startAmount: action.amount
                },
            };
        case "SET_APPLICATION_AMOUNT_STATIC":
            return {
                ...state,
                data: {
                    ...state.data,
                    loanAmount: action.amount
                },
                currentStep: Step.AmountLanding
            };
        case "SET_APPLICATION_REPAYMENT_PERIOD":
            return {
                ...state,
                data: {
                    ...state.data,
                    repaymentPeriod: action.months
                }
            };
        case "APPLICATION_SET_ID":
            return {
                ...state,
                application: {
                    ...state.application,
                    id: action.id
                }
            };
        case "APPLICATION_GOTO": {
            return {
                ...state,
                currentStep: action.step
            };
        }
        case "APPLICATION_SET_CONTACT_INFO": {
            return {
                ...state,
                currentStep: Step.RKI,
                data: {
                    ...state.data,
                    name: action.name,
                    email: action.email,
                    mobile: action.mobile,
                    //address: action.address,
                    //postalcode: action.postalcode,
                    //city: action.city,
                }
            };
        }
        case "APPLICATION_SET_ASE_CONSENT": {
            return {
                ...state,
                data: {
                    ...state.data,
                    aseConsent: action.aseConsent,
                }
            };
        }
        case "APPLICATION_SET_ALMBRAND_CONSENT": {
            return {
                ...state,
                data: {
                    ...state.data,
                    almBrandConsent: action.almBrandConsent,
                }
            };
        }
        case "APPLICATION_SET_RKI": {
            return {
                ...state,
                currentStep: Step.LoanReason,
                data: {
                    ...state.data,
                    rki: action.rkiRegistered
                }
            };
        }
        case "APPLICATION_SET_LOAN_REASON": {
            return {
                ...state,
                currentStep: Step.Marital,
                data: {
                    ...state.data,
                    reasonOfLoan: action.reason

                }
            };
        }
        case "APPLICATION_SET_OTHER_LOAN_REASON": {
            return {
                ...state,
                currentStep: Step.Marital,
                data: {
                    ...state.data,

                    otherReasonOfLoan: action.otherReason
                }
            };
        }
        case "APPLICATION_SET_MARRIED": {
            return {
                ...state,
                currentStep: Step.Children,
                data: {
                    ...state.data,
                    married: action.married,
                    sharedExpenses: action.sharedExpenses,
                    maritalExpenses: action.maritalExpenses
                }
            };
        }
        case "APPLICATION_SET_CHILDREN_COUNT": {
            return {
                ...state,
                currentStep: Step.Coappliant,
                data: {
                    ...state.data,
                    children: action.children
                }
            };
        }
        case "APPLICATION_SET_HAS_COAPPLICANT": {
            const nextStep = action.hasCoApplicant
                ? Step.CoappliantContact
                : Step.Dwelling;
            return {
                ...state,
                currentStep: nextStep,
                data: {
                    ...state.data,
                    coappliant: action.hasCoApplicant
                }
            };
        }
        case "APPLICATION_SET_COCONTACT_INFO": {
            return {
                ...state,
                currentStep: Step.Dwelling,
                data: {
                    ...state.data,
                    coname: action.name,
                    coemail: action.email,
                    cocpr: action.cpr
                }
            };
        }
        case "APPLICATION_SET_DWELLING": {
            return {
                ...state,
                currentStep: Step.Cars,
                data: {
                    ...state.data,
                    dwelling: action.dwelling,
                    rent: action.rent
                }
            };
        }
        case "APPLICATION_SET_CARCOUNT": {
            return {
                ...state,
                currentStep: Step.Payment,
                data: {
                    ...state.data,
                    cars: action.cars
                }
            };
        }
        case "APPLICATION_SET_CPR_PAYMENT": {
            return {
                ...state,
                currentStep: Step.Consent,

                data: {
                    ...state.data,
                    cpr: action.cpr,
                    paymentMethod: action.paymentMethod,
                    hasOldLoan: action.hasOldLoan,
                    oldLoanAmount: action.oldLoanAmount,
                    accountNr: action.accountNr,
                    regNr: action.regNr
                }
            };
        }
        case "APPLICATION_SET_CONSENT": {
            return {
                ...state,
                currentStep: Step.Callback,
                data: {
                    ...state.data,
                    termsOfService: action.termsOfService,
                    marketing: action.marketing,
                    insurance: action.insurance,
                    creditCheck: action.creditCheck,
                    eSkatConsent: action.eSkat
                }
            };
        }
        case "APPLICATION_SET_APPLICATION_SENDING": {
            return {
                ...state,
                application: {
                    ...state.application,
                    sending: action.sending,
                    error: action.error
                }
            };
        }
        case "APPLICATION_SET_APPLICATION_RESPONSE": {
            return {
                ...state,
                application: {
                    ...state.application,
                    data: action.response
                }
            };
        }
        default: {
            //console.warn(action.type + " not implemented");
            break;
        }
    }
    return state;
}

export default applicationReducer;
